<template>
  <div class="forms">
    <SessionStatus v-if="submitted" v-bind:submissionId="submissionId" display="true" fieldsToFilter="barcode_" @resetEnquiry="resetEnquiry" />
    <Submitted v-if="submitted" @resetEnquiry="resetEnquiry" />    
    <TheStakeholderRequestForm v-else @submitEnquiry="submitEnquiry" />
    <TheStakeholderRequestPrivacyNotice />
  </div>
</template>

<script>
import TheStakeholderRequestPrivacyNotice from '@/components/stakeholderrequest/TheStakeholderRequestPrivacyNotice.vue'
import TheStakeholderRequestForm from '@/components/stakeholderrequest/TheStakeholderRequestForm.vue'
import Submitted from '@/components/stakeholderrequest/Submitted.vue'
import SessionStatus from '@/components/session/SessionStatus.vue'

export default {
  name: 'TheStakeholderRequest',
  components: {
    TheStakeholderRequestForm,
    Submitted,
    SessionStatus,
    TheStakeholderRequestPrivacyNotice
  },
  data: function() {
    return {
      submitted: false,
      submissionId: ''
    }
  },
  methods: {
    submitEnquiry: function(result) {
      this.submitted = result.response == 'OK';
      this.submissionId = result.submissionId;
      scroll(0, 0);
    },
    resetEnquiry: function() {
      this.submitted = false;
      scroll(0, 0); 
    }
  }
}
</script>

